export const DEFAULT_BOX_SHADOW = 1;
